<template>

  <div class="animated fadeIn">
    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-check-square text-primary mr-2"></i>
          Nueva Lista de Distribución
        </h4>
      </b-col>
    </b-row>

    <b-row md="12" class="pb-3">
      <b-col class="col-md-12">
        <b-row md="12">

          <b-card class="w-100">
            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
              Contactos
            </b-row>
            <b-row md="12" class="mb-3 border-top-primary px-2">
              <b-col class="col-md-9">
                <b-form-group label="Buscar" :label-cols="3" :horizontal="true" class="w-100 mb-0">
                  <b-form-input
                    id="string"
                    name="string"
                    type="text"
                    placeholder="Busqueda general"
                    v-model="entity.string"
                    class="w-100"
                    v-validate="'min:3'"
                    :state="validateState('string')"
                    aria-describedby="check_string"></b-form-input>
                  <div class="text-danger text-right" id="check_string">
                    <small>{{ errors.first('string') }}</small>
                  </div>
                </b-form-group>
              </b-col>

              <b-col class="col-md-3">
                <button
                  class="btn btn-pill btn-primary ml-4 float-right"
                  @click="search">Buscar Contacto
                </button>
              </b-col>

            </b-row>

            <v-server-table
              :columns="columns"
              :options="options"
              :theme="theme"
              class="dataTable"
              ref="dataContactTable"
              md="12"
              lg="12"
              sm="12"
              @sorted="tableSorted">
              <template slot="beforeBody">
                <tr v-if="loading">
                  <td class="text-center loading" colspan="7"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
                </tr>
              </template>
              <template slot="select" slot-scope="props">
                <input type="checkbox" :value="props.row.uuid" :checked="isSelected(props.row.uuid)" @change="toggleSelected(props.row.uuid)">
              </template>
            </v-server-table>
            <b-row>
              <div class="col float-left">
                <button
                  type="submit"
                  class="btn btn-brand btn-primary btn-lg pull-right"
                  :disabled="!atLeastOneSelected"
                  @click="saveSelectedData"
                  >
                  Guardar
                </button>
              </div>
            </b-row>
          </b-card>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import Vue from 'vue';
import form from '@/helpers/form';
import {ServerTable, Event} from 'vue-tables-2';
import Spinner from 'vue-simple-spinner';
import { mapGetters } from 'vuex';

Vue.use(ServerTable);

export default {
  name: 'ListContactForDistributionList',
  components: {
    Spinner
  },
  data: function () {
    return {
      topmenu: [
        {name: 'Volver', path: '/communications/distribution-list/add', brand: 'fa fa-arrow-left'},
      ],
      entity: {
        string: null,
        page: 1,
        itemsPerPage: 10,
      },
      orderBy: {
        column: null,
        ascending: null
      },
      count: 0,
      loading: true,
      selectedContactIds: [],
      options: {
        headings: {
          select: {
            text: ''
          },
          name: 'Nombre',
          surname: 'Apellidos',
          email: 'Email'
        },
        requestFunction: data => {
          if (this.$store.getters.getFilters[0] !== null) {
            this.entity.string = this.$store.getters.getFilters[0];
          }
          this.entity.page = data.page;
          this.entity.itemsPerPage = data.limit;
          let self = this;
          return axios({
            url: 'contacts/',
            method: 'get',
            params: this.searchFilters
          }).catch(function (e) {
            self.dispatch('error', e);
          }.bind(this));
        },
        responseAdapter: ({data}) => {
          return {
            data: data.contacts,
            count: data.count
          }
        },
        columnsClasses: {uuid: "fit", select: 'select'},
        sortable: ['name', 'surname', 'email'],
        filterable: false,
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        perPageValues: [10, 25, 50, 100, 500, 1000, 10000, 100000],
        texts: form.tableLabels(),
        pagination: {
          chunk: 10,
          edge: true,
          nav: 'scroll'
        }
      },
      columns: [
        'select',
        'name',
        'surname',
        'email'
      ],
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
      strings: ['companyWorkersNumber'],
      arrays: ['addresses']
    }
  },
  mounted() {
    this.$_loadingMixin_showLoading();
    this.fetchStoredContacts();
    Event.$on('vue-tables.loading', (data) => {
      this.$_loadingMixin_showLoading();
      this.count = 0;
      this.loading = true;
      if (!!document.querySelector('.VueTables__no-results')) {
        document.querySelector('.VueTables__no-results').style.display = 'none';
      }
    });
    Event.$on('vue-tables.loaded', (data) => {
      if (!!data && !!data.data && !!data.data.count) {
        this.count = data.data.count;
      }
      this.$_loadingMixin_hideLoading();
      this.loading = false;
      if (!!document.querySelector('.VueTables__no-results')) {
        document.querySelector('.VueTables__no-results').style.display = 'table-row';
      }
    });

    this.$eventHub.$emit('captureMenu', this.topmenu);
  },
  computed: {
    ...mapGetters(['getContacts']),
    searchFilters() {
      return {
        string: this.entity.string,
        page: this.entity.page,
        itemsPerPage: this.entity.itemsPerPage,
        orderColumn: this.orderBy.column,
        orderAscending: this.orderBy.ascending ? 1 : 0
      }
    },
    atLeastOneSelected() {
      return this.selectedContactIds.length > 0;
    },
  },
  methods: {
    isSelected(uuid) {
      return this.selectedContactIds.includes(uuid);
    },
    toggleSelected(uuid) {
      if (this.isSelected(uuid)) {
        this.selectedContactIds = this.selectedContactIds.filter(id => id !== uuid);
      } else {
        this.selectedContactIds.push(uuid);
      }
    },
    fetchStoredContacts() {
      const storedContacts = this.getContacts;
      if (storedContacts){
        storedContacts.forEach(contact => {
          const uuid = contact.uuid;
          if (!this.selectedContactIds.includes(uuid)) {
            this.selectedContactIds.push(uuid);
          }
        });
      }
    },
    saveSelectedData() {
      const totalRecords = this.count;
      const selectedCount = this.selectedContactIds.length;

      const response = {
        selectedIds: this.selectedContactIds,
        totalRecords,
        selectedCount
      };

      this.$store.commit('SET_LIST_CONTACT_RESPONSE', response);

      if (this.$route.query.hasOwnProperty('distributionListUUId')){
         this.$router.push({
          path: '/communications/distribution-list/edit/'+this.$route.query.distributionListUUId
        });
        this.$_loadingMixin_hideLoading();
      }else{
        this.$router.push({
          path: '/communications/distribution-list/add'
        });
        this.$_loadingMixin_hideLoading();
      }
    },
    search() {
      let filterData = [];
      filterData.push(this.entity.string);
      this.$store.commit('SET_FILTERS_LIST', filterData);
      this.$refs.dataContactTable.refresh();
    },
    validate() {
      // FIXME
      return true;
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      } else {
        return null;
      }
    },
    normalizeContact(contact) {
      return {
        'Nombre': contact.name,
        'Apellidos': contact.surname,
        'Emails': contact.email,
      }
    },
    tableSorted(data) {
      this.orderBy.column = data.column;
      this.orderBy.ascending = data.ascending;
    }
  },
}
</script>

<style lang="scss">
.VueTables__no-results {
  display: none;
}
</style>
